import { IComponentOptions } from 'angular';
import { LicensePaymentWizardViewController } from './license-payment-wizard-view.controller';
import template from './license-payment-wizard-view.component.html';

export const LicensePaymentWizardViewComponent = {
	bindings: {
		onError: '&',
		onSuccess: '&'
	},
	controller: LicensePaymentWizardViewController,
	require: {
		wizardController: '^wizard'
	},
	template
} as IComponentOptions;
